import {Box, Button, Stack, Typography} from "@mui/material";
import coin from "../../../public/coin-svgrepo-com.svg";

interface IGenerateButtonProps {
    price: number;
    disabled?: boolean;
    onClick: () => void;
}

export const GenerateButton = ({price, disabled, onClick}: IGenerateButtonProps) => {
    return (
        <Button
            onClick={onClick}
            variant="contained"
            fullWidth
            disabled={disabled}
        >
            <Stack direction="row" alignItems="center" spacing={1}>
                <Typography variant="body1" sx={{fontWeight: 600}}>
                    Generate
                </Typography>
                <Typography variant="body1">
                    {price}
                </Typography>
                <Box
                    component="img"
                    src={coin}
                    alt="coin"
                    sx={{width: '16px', height: '16px'}}
                />
            </Stack>
        </Button>
    );
};
